export const cids = {
  index: 'c_pay_cze95t45',
  payment: 'c_pay_2rtls4aq',
  records: 'c_pay_qm540czq',
  introduction: 'c_pay_whl3yhj9',
  result: 'c_pay_26snlgaq', // 支付签约流程中，支付失败中间垫付结果页
  openedResult: 'c_pay_lawk9aes',
  confirmationDialog: 'c_pay_37b15cl3', // 后付下单二次确认页
};

export const bids = {
  signPayBtn: 'b_pay_er44gmta_mc',
  signPayBtnMV: 'b_pay_er44gmta_mv',
  clickOrderBtn: 'b_pay_uegfym8c_mc',
  showOrderBtn: 'b_pay_uegfym8c_mv',
  clickSignFailModal: 'b_pay_evybqe04_mc',
  showSignFailModal: 'b_pay_evybqe04_mv',
  showBusinessBtn: 'b_pay_m01t653g_mc',
  openCashierBtn: 'b_pay_juuj3svl_mc',
  recordDetailClick: 'b_pay_1jbtx3sf_mc',
  closeRecordPage: 'b_pay_9a9ss47h_mc',
  signSuccessMC: 'b_pay_fzwssyjf_mc',
  bubbleTextMV: 'b_pay_g5re4xag_mv',
  goPayBtn: 'b_pay_zbi3zvim_mc',
  // 支付签约流程中，支付失败中间垫付结果页
  deferGoPay: {
    mc: 'b_pay_r2e6fyvj_mc',
  },
  noema: {
    mv: 'b_pay_hwgc6eo0_mv',
    mc: 'b_pay_hwgc6eo0_mc',
  },
  payDelayDeductionMC: 'b_pay_7tk2n7sl_mc',
  payDelayBtnMV: 'b_pay_er44gmta_mv',
  payDelayBubbleTextMV: 'b_pay_5z124o9j_mv',
  closeSuspend: 'b_pay_tjmfvug2_mc',
  signOtherProductsContentMV: 'b_pay_krxdcp6w_mv',
  signOtherProductsContentMC: 'b_pay_krxdcp6w_mc',
  // 签约并支付页-支付营销
  pagePromoMV: 'b_pay_4cej5f3e_mv',
  pagePromoMC: 'b_pay_4cej5f3e_mc',
  // 已开通后付详情页-后付营销信息展示
  openedPagePromoMV: 'b_pay_ncv7rcof_mv',
  openedPagePromoMC: 'b_pay_ncv7rcof_mc',
  // 后付下单二次确认页
  confirmationDialogConfirmMC: 'b_pay_fvcwgyms_mc', // 使用先用后付按钮MC todo
  confirmationDialogPayMC: 'b_pay_v0i2xevj_mc', // 普通支付按钮MC todo
  confirmationDialogCloseMC: 'b_pay_k4fjflrq_mc', // 弹窗右上角关闭按钮MC
};
export const sc = {
  ajaxRequestStart: 'b_pay_paydefer_request_start_sc',
  ajaxRequestSuccess: 'b_pay_paydefer_request_succ_sc',
};
